import { render, staticRenderFns } from "./max-characters.vue?vue&type=template&id=28562549&"
import script from "./max-characters.vue?vue&type=script&lang=js&"
export * from "./max-characters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports